export const SelfServicesPermissions = {
    InternalVacancies: {
        key: 'd6d5826a989f4538903bdf3f04c3fa65',
    },
    WorkflowApprovals: {
        key: 'e281dcff46bc443ab26ff25b67b0cead',
    },
    JobRequisition: {
        key: 'b99b0fc757e446af969070ca6729ffaa'
    },
    NONBudgetedRequisition: {
        key: '46bed6d8099a4d9185461de6d3a5cf5d'
    },
    RequestVisaReservation: {
        key: '37866119037b4eafbaa702b9268a77e7',
    },
    ViewVisaReservation: {
        key: '42cc7212be424d1a81c641f2db6a567c',
    },
    CancelVisaReservation: {
        key: '6d262a00eb654e558f9d2ee99bc5ecb9',
    },
    ViewVisaAllocation: {
        key: '61a01fd81e4d4515a10ddcaf7ce15158',
    },
    RequestVisaAllocation: {
        key: '7cd12d746b724a9a9ee93871a5c03d89',
    },
    CancelVisaAllocation: {
        key: '6d262a00eb654e558f9d2ee99bc5ecb9',
    },
    ReserveOnBehalf: {
        key: 'b90c862b04e0475297574bc62ff53aa8',
    },
    AllocateOnBehalf: {
        key: '3678438ca1ce4e96b850089b260a767b',
    },
    ViewAllAllocationRequests: {
        key: 'd8c5c35aa6ed494b9379210cf3f9e0e2',
    },
    ViewAllReservationRequests: {
        key: 'cd87829a2bd04df1bd0ffd1570056a0b',
    },
    UploadAttachments: {
        key: '59e86ff3883946c480767192a00035f8',
    },
    ViewAttachments: {
        key: '80024ca63eed4d12b7bf7e2e91f163b8',
    },
    RequestMoreInformation: {
        key: '31c8fcfad7004f31983fac5b33304b93',
    },
    CreateTask: {
        key: '566f6b25412b4e4d82ef2440dce8bea0',
    },
    UpdateTask: {
        key: '52fa9a2a599742b3a73d5633c50e0ef3',
    },
    UpdateTaskStatus: {
        key: 'b31bf60a821543cdb58ab71e9e90f328',
    },
    DeleteTask: {
        key: '454c69f2e99840c09b0780dbf61b03f1',
    },
    ApprovalsTrackingDiscussion: {
        key: 'ffd09766d43058400def77485026d938',
    },
    AutoFillJobPost: {
        key: 'be94cfe8f1704f3798707fa78e230c76',
    },
    GenerateJobDescription: {
        key: '3938b1e4ba4343079211a1db19ca6ebc',
    },
    GenerateJobRequirements: {
        key: '3a71caaf1cdb474e8c22fc67edc16c78',
    },
    OptimizeJobDescription: {
        key: '346ed2a371c34cf48a091f69c8be719c',
    },
    OptimizeJobRequirements: {
        key: '2771c2edb62c4e5ba7d04921d367ffe7',
    },
};
